import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import RoutesList from '@/components/RoutesList.vue';
let ToolsPage = class ToolsPage extends Vue {
    get categories() {
        return [
            {
                category: '',
                routes: [
                    { to: '/tools/mycharacters', title: 'Character Creator' }
                ]
            }
        ];
    }
};
ToolsPage = __decorate([
    Component({
        components: {
            RoutesList
        }
    })
], ToolsPage);
export default ToolsPage;
